<template>
  <ModalHolder
    v-if="ownerInfo"
    :title="''"
    m-top="120"
    m-width="30%"
    m-height="35vh"
    :is-show="isShow"
  >
    <template slot="mheader">
      <div style="height: 20px;">
        <span style="position:absolute;right:15px;top:15px" @click="dismissModal()">
          <Icon size="20" type="close-circled"></Icon>
        </span>
        <strong>Invitation</strong>
      </div>
    </template>
    <template slot="mcontent" style="display: flex;">
      <p align="center" style="height: 50%; justify-content: center; align-items: center;">
        <progressive-img
          v-if="ownerInfo"
          style="max-width: 120px; width:120px"
          :src="userDisplayImage(ownerInfo)"
        />
      </p>
      <h4 v-if="!isAccepted" align="center" style="height: 50%">
        <p>You have been invited to join</p>
        <p>{{ownerInfo.display_name}}'s</p>
        <p>care team.</p>
      </h4>
      <h4 v-else align="center">
        <p>You have already accepted this invitation</p>
      </h4>
    </template>
    <template slot="mfooter">
      <div v-if="!isAccepted">
        <Button type="error" style="float: left;" @click="rejectInvite()">Decline</Button>
        <Button type="primary" @click="acceptInvite()">Accept</Button>
      </div>
      <div v-else>
        <Button @click="proceed()">Proceed</Button>
      </div>
    </template>
  </ModalHolder>
</template>

<script>
import ModalHolder from "@/components/ModalHolderComponent";
import Utils from "@/utils.js";
import VueCookie from "vue-cookie";
import axios from "axios";
import _ from "lodash";
import * as API from "@/endpoints";

export default {
  name: "CareTeamJoinConsentModal",
  data() {
    return {
      invitationInfo: null,
      ownerInfo: null
    };
  },
  props: {
    isShow: Boolean,
    prescriberId: String,
    journalCareplanId: String,
    invitationId: String,
    isRequest: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isShow(n, o) {
      if (n && this.invitationId) {
        this.loadCareTeamOwnerViaInviteId();
      }
    }
  },
  mounted() {
    if (this.isShow && this.invitationId) {
      this.loadCareTeamOwnerViaInviteId();
    }
  },
  computed: {
    isAccepted() {
      return _.get(this.invitationInfo, "is_accepted", false);
    }
  },
  methods: {
    proceed() {
      this.$router.push(`/profile/${this.ownerInfo.id}?tab=team`);
      this.dismissModal();
    },
    loadCareTeamOwner() {
      this.$store
        .dispatch("careteam/getCareTeamOwner", { id: this.prescriberId })
        .then(res => {
          this.ownerInfo = res;
        });
    },
    loadCareTeamOwnerViaInviteId() {
      axios
        .get(API.endpoints.prescribe + "/careplan/" + this.invitationId)
        .then(res => {
          this.invitationInfo = res.data;
          this.ownerInfo = this.invitationInfo.prescriber;
        });
    },
    acceptInvite() {
      console.log(":::", this.isRequest)
      if (this.isRequest) {
        this.$store
          .dispatch("careteam/acceptCareTeamRequest", {
            id: this.invitationId
          })
          .then(res => {
            this.dismissModal();
            this.$router.push(`/profile/${this.ownerInfo.id}`);
          })
          .finally(() => {
            this.clearPrescriptionCookies();
            this.dismissModal();
          });
      } else {
        this.$store
          .dispatch("careteam/acceptCareTeamPrescribe", {
            id: this.journalCareplanId
          })
          .then(res => {
            this.dismissModal();
            this.$router.push(`/profile/${this.ownerInfo.id}`);
          })
          .finally(() => {
            this.clearPrescriptionCookies();
            this.dismissModal();
          });
      }
    },
    clearPrescriptionCookies() {
      VueCookie.delete("PRESCRIPTION_CODE");
      VueCookie.delete("PRESCRIPTION_GROUP");
      VueCookie.delete("PRESCRIPTION_USER_STORY");
      VueCookie.delete("PRESCRIPTION_CODE_TYPE");
      VueCookie.delete("PRESCRIPTION_PRESCRIBED_BY");
    },
    rejectInvite() {
      this.$store
        .dispatch("careteam/rejectCareTeamInvite", {
          id: this.journalCareplanId
        })
        .finally(() => {
          this.clearPrescriptionCookies();
          this.dismissModal();
        });
    },
    dismissModal() {
      this.$emit("close");
      this.$router.replace({
        query: {
          ...this.$route.query,
          care_team_request_code: null
        }
      });
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage("user", user, "medium");
    }
  },
  components: {
    ModalHolder
  }
};
</script>